import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  NavDropdown,
  Form,
  FormControl,
  Button,
  Badge,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import "./navBar.css";
import avatarImg from "./../../images/profile.png";
import shopImg from "./../../images/shopping-cart-nav.png";
import { useHistory } from "react-router";

const NavBar = ({ cartProducts }) => {
  const [userToken, setUserToken] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("user"));
    if (token) {
      setUserToken(token);
    }
    console.log("token effect running");
  }, []);

  return (
    <Navbar expand="sm" className="fixed-top nav_bg_color">
      <Navbar.Brand href="#home">Gym Hero</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto d-flex align-items-center">
          <Link to="/home" className="nav-link">
            Home
          </Link>

          <Link to={void 0} className="nav-link">
            About
          </Link>
          <Link to={void 0} className="nav-link">
            Contact
          </Link>

          <Link to="/dashboard" className="nav-link d-none d-md-block">
            Dashboard
          </Link>

          <Link to="/cart" className="nav-link">
            <div className="d-flex">
              {/* <FontAwesomeIcon
                icon={faShoppingCart}
                size="2x"
                className="brand_text"
              /> */}
              <img
                src={shopImg}
                width="50px"
                height="50px"
                alt="shop"
                className="nav-link"
              />
              <Badge className="text-danger" variant="transparent">
                <h5>{cartProducts?.length}</h5>
              </Badge>
            </div>
          </Link>

          {userToken ? (
            <Dropdown className="nav-link bg-transparent">
              <Dropdown.Toggle
                variant="transparent"
                className="bg-transparent"
                id="dropdown-basic"
              >
                <img src={avatarImg} className="avatar" alt="avatar" />
              </Dropdown.Toggle>

              <Dropdown.Menu className="bg-white">
                <Dropdown.Item
                  href={void 0}
                  onClick={() => alert("comming soon")}
                >
                  Profile
                </Dropdown.Item>
                <Dropdown.Item
                  href={void 0}
                  onClick={() => history.push("/dashboard")}
                  className="d-block d-md-none"
                >
                  Dashboard
                </Dropdown.Item>
                <Dropdown.Item
                  href={void 0}
                  onClick={() => history.push("/dashboard/giveReview")}
                >
                  Review
                </Dropdown.Item>
                <Dropdown.Item
                  href={void 0}
                  onClick={() => {
                    localStorage.removeItem("user");
                    setUserToken(null);
                  }}
                >
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Link to="/login" className="nav-link">
              <button>Login</button>
            </Link>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavBar;
